import { Box } from 'app/components/design-system-components'
import MuvalLogoAndDesc from 'app/Integrations/components/Muval/ImageAndText'
import MuvalLink from 'app/Integrations/components/Muval/MuvalLink'
import MuvalPreApprovedButton from 'app/Integrations/components/Muval/PreApprovedButton'
import { StyledUl } from 'app/Integrations/components/RentBond/styles'
import { GTM_MUVAL_DASHBOARD_CTA_BUTTON } from 'app/utils/google-tag-manager/helpers'

function MuvalTile() {
  const dashboardMuvalText = (
    <Box>
      <strong>Moving Made Easy!</strong>
      <StyledUl>
        <li>Book instantly online.</li>
        <li>Australia-wide network of verified removalists.</li>
        <li>$5,000 complimentary cover with MuveXpress.</li>
      </StyledUl>
      <MuvalLink textInLink="Learn more" />
    </Box>
  )

  return (
    <li className="renter-dashboard-li">
      <Box width="100%" height="100%">
        <Box>
          <MuvalLogoAndDesc text={dashboardMuvalText} />
          <Box mt={5}>
            <MuvalPreApprovedButton
              trackingClassName={GTM_MUVAL_DASHBOARD_CTA_BUTTON}
            />
          </Box>
        </Box>
      </Box>
    </li>
  )
}

export default MuvalTile
